export default __webpack_public_path__ + "static/media/HalyardTextSemBd.a449f95f.woff";